import React from 'react';

import { GetGamePlayerInstance } from '../../../../GamePlayer';

function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = function(query) {
        return window.matchMedia(query).matches;
    };

    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

class MobileControls extends React.Component {
    jump = e => {
        e.preventDefault();
        if (!GetGamePlayerInstance().game.keys.ArrowUp && !GetGamePlayerInstance().game.downKeys.ArrowUp) {
            GetGamePlayerInstance().game._downKeys.push('ArrowUp');
            GetGamePlayerInstance().game.downKeys.ArrowUp = true;
        }
    };

    jumpEnd = e => {
        if (GetGamePlayerInstance().game.keys.ArrowUp && !GetGamePlayerInstance().game.upKeys.ArrowUp) {
            GetGamePlayerInstance().game._upKeys.push('ArrowUp');
            GetGamePlayerInstance().game.upKeys.ArrowUp = true;
        }
    };

    render() {
        const { enabled } = this.props;

        if (enabled && isTouchDevice()) {
            return (
                <div className="bottom pointer-events-none">
                    <div className="pointer-events-none" id="gameplayer-jump-buttons">
                        <div className="screen-button jump-button" onTouchStart={this.jump} onTouchEnd={this.jumpEnd}>
                            <span></span>
                        </div>
                        <div className="screen-button jump-button" onTouchStart={this.jump} onTouchEnd={this.jumpEnd}>
                            <span></span>
                        </div>
                    </div>
                </div>
            );
        }
        return <div />;
    }
}

export default MobileControls;
